// extracted by mini-css-extract-plugin
module.exports = {"fullPage":"src-hellospa-page-prep-and-send-data-types-workflow__fullPage--3SG_f"};